"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsOfStrNumber = exports.formatToFixedString = exports.formatToFixed = exports.toFixedNoRound = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const constants_1 = require("../constants");
const toFixedNoRound = (number, precision = constants_1.CALCULATION_RESULT_PRECISION) => {
    return +new bignumber_js_1.default(number).toFixed(precision, bignumber_js_1.default.ROUND_DOWN);
};
exports.toFixedNoRound = toFixedNoRound;
const formatToFixed = (number, precision = constants_1.CALCULATION_RESULT_PRECISION) => {
    const value = number instanceof bignumber_js_1.default ? number.toNumber() : number;
    return (0, exports.toFixedNoRound)(value, precision);
};
exports.formatToFixed = formatToFixed;
const formatToFixedString = (number, precision = constants_1.CALCULATION_RESULT_PRECISION) => {
    return (0, exports.formatToFixed)(number, precision).toString();
};
exports.formatToFixedString = formatToFixedString;
const AbsOfStrNumber = (strNumber) => {
    return strNumber.replace(/^-/, '');
};
exports.AbsOfStrNumber = AbsOfStrNumber;
//# sourceMappingURL=number-utils.js.map